// Mirrors §2 of the brief — these values are persisted to IndexedDB,
// so do NOT rename string literals without a content migration.

export type Language = "uk" | "ru" | "en";
export const LANGUAGES: readonly Language[] = ["uk", "ru", "en"] as const;
export const DEFAULT_LANGUAGE: Language = "uk";

export type ModeId = "family" | "friends" | "party" | "alco" | "couples";

export interface ModeMeta {
  id: ModeId;
  isAdult: boolean;
}

export const MODES: readonly ModeMeta[] = [
  { id: "family", isAdult: false },
  { id: "friends", isAdult: false },
  { id: "party", isAdult: false },
  { id: "alco", isAdult: true },
  { id: "couples", isAdult: true },
] as const;

export type CardType =
  | "question"
  | "task"
  | "mini_challenge"
  | "vote"
  | "pair"
  | "group";

export const CARD_TYPES: readonly CardType[] = [
  "question",
  "task",
  "mini_challenge",
  "vote",
  "pair",
  "group",
] as const;

export type Phase = "warmup" | "engagement" | "peak";
export const PHASE_ORDER: Record<Phase, number> = {
  warmup: 0,
  engagement: 1,
  peak: 2,
};

/**
 * Phase from progress fraction (cardsSeen / totalCards) — §3.4.
 *  < 0.34 → WARMUP
 *  < 0.70 → ENGAGEMENT
 *  ≥ 0.70 → PEAK
 */
export function phaseFromFraction(fraction: number): Phase {
  if (fraction >= 0.7) return "peak";
  if (fraction >= 0.34) return "engagement";
  return "warmup";
}

export type ActionResult = "done" | "failed" | "skipped" | "replaced";

export type PackStatus = "not_started" | "in_progress" | "completed";

export function modeIsAdult(modeId: ModeId): boolean {
  return MODES.find((m) => m.id === modeId)?.isAdult ?? false;
}
